export const BillIcon = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* White circular background */}
      <circle cx="23" cy="23" r="23" fill="white" />

      <rect x="0.5" y="0.5" width="45" height="45" rx="22.5" stroke="#916CF1" />
      <path
        d="M28.6143 11.0835H16.0101C14.6179 11.0835 13.4893 12.2121 13.4893 13.6043V36.2918L16.6403 33.771L19.1611 36.2918L22.3122 33.771L25.4632 36.2918L27.9841 33.771L31.1351 36.2918V13.6043C31.1351 12.2121 30.0065 11.0835 28.6143 11.0835Z"
        fill="white"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5312 16.125H26.0938"
        stroke="#F7AD3C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5312 21.1665H26.0938"
        stroke="#FD561F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5312 26.2085H19.7917"
        stroke="#19AE57"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
